import './Privacy.css';

const Privacy = () => {
    return (
        <div className="privacy-page">
            <section className="page-header">
                <div className="container">
                    <h1 className="page-title">Aviso de Privacidad</h1>
                </div>
            </section>

            <section className="section container privacy-content">
                <p>
                    <strong>Última actualización: Noviembre 2024</strong>
                </p>
                <p>
                    En <strong>Consultorio de Genética Integral</strong>, la privacidad y seguridad de su información es nuestra prioridad.
                    De conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, ponemos a su disposición el presente Aviso de Privacidad.
                </p>

                <h3>1. Responsable de los datos</h3>
                <p>
                    El Consultorio de Genética Integral, con domicilio en Av. Médica 123, Consultorio 405, Ciudad de México, es responsable del uso y protección de sus datos personales.
                </p>

                <h3>2. Finalidad del tratamiento de datos</h3>
                <p>
                    Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades que son necesarias para el servicio que solicita:
                </p>
                <ul>
                    <li>Creación y actualización de expediente clínico.</li>
                    <li>Prestación de servicios médicos y genéticos.</li>
                    <li>Contacto para seguimiento de citas y resultados.</li>
                    <li>Facturación y cobro.</li>
                </ul>

                <h3>3. Datos sensibles</h3>
                <p>
                    Le informamos que para cumplir con las finalidades previstas en este aviso de privacidad, serán recabados y tratados datos personales sensibles,
                    como aquellos que refieren a su estado de salud presente y futuro, información genética, antecedentes médicos, entre otros.
                    Nos comprometemos a que los mismos serán tratados bajo las más estrictas medidas de seguridad que garanticen su confidencialidad.
                </p>

                <h3>4. Derechos ARCO</h3>
                <p>
                    Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso).
                    Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación);
                    que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada conforme a los principios, deberes y obligaciones previstas en la normativa (Cancelación);
                    así como oponerse al uso de sus datos personales para fines específicos (Oposición).
                </p>

                <p>
                    Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través del correo electrónico: privacidad@geneticaintegral.com
                </p>
            </section>
        </div>
    );
};

export default Privacy;
